module.exports = __webpack_public_path__ + "static/assets/663892634c556da228c1d09301a54e63.svg";